/* Brndpwr — gedeelde site-interacties */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveals (rect-based, betrouwbaar in iframes) ---- */
  function inView(el, margin) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.top < h - (margin || 0) && r.bottom > 0;
  }
  function initReveals() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
    if (reduced) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    function check() {
      els = els.filter(function (e) {
        if (inView(e, 40)) { e.classList.add('in'); return false; }
        return true;
      });
    }
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
  }

  /* ---- animated counters ---- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var dur = parseInt(el.getAttribute('data-dur') || '1400', 10);
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var sepThousands = el.getAttribute('data-thousands') === '1';
    if (reduced) { el.textContent = prefix + format(target) + suffix; return; }
    var start = performance.now();
    function format(v) {
      var s = dec ? v.toFixed(dec).replace('.', ',') : Math.round(v).toString();
      if (sepThousands) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return s;
    }
    function frame(now) {
      var p = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + format(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = prefix + format(target) + suffix;
    }
    requestAnimationFrame(frame);
  }
  function initCounters() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-count]'));
    function check() {
      els = els.filter(function (e) {
        if (inView(e, 60)) { animateCount(e); return false; }
        return true;
      });
    }
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('load', check);
  }

  /* ---- segmented control (verplaatst thumb) ---- */
  function initSeg(seg, onChange) {
    var thumb = seg.querySelector('.thumb');
    var btns = Array.prototype.slice.call(seg.querySelectorAll('button'));
    function place(active) {
      btns.forEach(function (b) { b.classList.toggle('on', b === active); });
      if (thumb) {
        thumb.style.width = active.offsetWidth + 'px';
        thumb.style.transform = 'translateX(' + (active.offsetLeft - btns[0].offsetLeft) + 'px)';
      }
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        place(b);
        if (onChange) onChange(b.getAttribute('data-val'), b);
      });
    });
    var init = seg.querySelector('button.on') || btns[0];
    requestAnimationFrame(function () { place(init); });
    window.addEventListener('resize', function () {
      place(seg.querySelector('button.on') || btns[0]);
    });
    return { set: function (val) {
      var b = btns.filter(function (x) { return x.getAttribute('data-val') === val; })[0];
      if (b) { place(b); }
    }};
  }
  window.BrndSeg = initSeg;

  /* ---- cursor glow op donkere hero ---- */
  function initGlow() {
    if (reduced) return;
    document.querySelectorAll('[data-glow]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
        el.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  /* ---- FAQ accordion ---- */
  function initFaq() {
    document.querySelectorAll('.faq-item .faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.faq-item');
        var open = item.classList.contains('open');
        item.classList.toggle('open', !open);
        q.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* ---- parallax (data-parallax="0.2") ---- */
  function initParallax() {
    if (reduced) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (!els.length) return;
    var vh = window.innerHeight;
    function upd() {
      els.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
        var r = el.getBoundingClientRect();
        var center = r.top + r.height / 2;
        var off = (center - vh / 2) * -speed;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
    }
    upd();
    (function(){var q=false;window.addEventListener('scroll',function(){if(q)return;q=true;requestAnimationFrame(function(){q=false;upd();});},{passive:true});})();
    window.addEventListener('resize', function () { vh = window.innerHeight; upd(); });
  }

  /* ---- tilt-on-scroll (data-tilt) — kantelt recht terwijl 't in beeld komt ---- */
  function initTilt() {
    if (reduced) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-tilt]'));
    if (!els.length) return;
    var vh = window.innerHeight;
    function upd() {
      els.forEach(function (el) {
        var maxTilt = parseFloat(el.getAttribute('data-tilt')) || 14;
        var r = el.getBoundingClientRect();
        var p = 1 - Math.min(1, Math.max(0, (r.top - vh * 0.15) / (vh * 0.7)));
        var rx = (1 - p) * maxTilt;
        el.style.setProperty('--rx', rx.toFixed(2) + 'deg');
      });
    }
    upd();
    (function(){var q=false;window.addEventListener('scroll',function(){if(q)return;q=true;requestAnimationFrame(function(){q=false;upd();});},{passive:true});})();
    window.addEventListener('resize', function () { vh = window.innerHeight; upd(); });
  }

  /* ---- auto-stagger: geef .reveal-kinderen oplopende delay ---- */
  function initStagger() {
    document.querySelectorAll('[data-stagger]').forEach(function (wrap) {
      var step = parseInt(wrap.getAttribute('data-stagger') || '90', 10);
      var i = 0;
      Array.prototype.forEach.call(wrap.children, function (c) {
        if (c.classList && c.classList.contains('reveal')) {
          c.style.setProperty('--d', (i * step) + 'ms');
          i++;
        }
      });
    });
  }

  function boot() {
    initStagger(); initReveals(); initCounters(); initGlow(); initFaq();
    initParallax(); initTilt();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
